import { Box, Grid, Typography } from "@mui/material";
import { MprcContainer } from "components";
import { ChannelAutoCompleteDataModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { MprcChipSuggestion } from "components/MprcChipSuggestion";
import { GetPublicationChannelDto, GroupInfo } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { ChannelAutoComplete } from "views/knowledge/channels/components/ChannelAutoComplete";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface IPublicationChannelBoxValidation {
    channel?: boolean;
}

interface IDataProps {
    channel: GetPublicationChannelDto | null;
    validation: IPublicationChannelBoxValidation;
}

interface IProps extends IDataProps {
    suggestions: ChannelAutoCompleteDataModel[];
    onUpdateState: (data: IDataProps) => void;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const PublicationChannelBox: React.FC<IProps> = ({ channel, suggestions, onUpdateState }) => {
    const { t } = useTranslation("knowledge");

    const selectedItems: ChannelAutoCompleteDataModel[] = channel == null
        ? []
        : [{ key: channel.channelId, label: channel.name, canDelete: true, isPrivate: channel.isPrivate, thumbnailUrl: channel.thumbnailUrl, usersGroup: {} as GroupInfo, fixed: false, selectable: false, fromHistory: false }];


    ///
    return (
        <>
            <MprcContainer>

                <Typography variant="button">{t("Publication.ChannelBox.Title") + "*"}</Typography>

                <ChannelAutoComplete
                    autoFocus
                    required
                    placeholder={t("Publication.ChannelBox.Placeholder")}
                    multiSelect={false}
                    selectedItems={selectedItems as ChannelAutoCompleteDataModel[]}
                    onChange={
                        (items) => onUpdateState({
                            channel: items.length == 0 ? null : { channelId: items[0].key, name: items[0].label, isPrivate: items[0].isPrivate, thumbnailUrl: items[0].thumbnailUrl! },
                            validation: { channel: items.length === 1 }
                        })
                    }
                    onError={() => { }}
                />

                {
                    suggestions.length > 0 &&
                    <Box>
                        <Grid container justifyContent="center" alignItems="baseline">
                            <Grid>
                                <Typography variant="captionHeader">{t("Publication.ChannelBox.Suggestions")}</Typography>
                            </Grid>
                            <Grid size="grow">
                                {
                                    suggestions.map((item, index) => (
                                        <MprcChipSuggestion key={index}
                                            label={item.label}
                                            title={item.label}
                                            onClick={() => onUpdateState({ channel: { channelId: item.key, name: item.label, isPrivate: item.isPrivate, thumbnailUrl: item.thumbnailUrl! }, validation: { channel: true } })}
                                        />
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </Box>
                }
            </MprcContainer>
        </>
    );
};
